var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":_vm.activeConnection,"items-per-page":-1},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-subheader',[_vm._v("Active connections")])]},proxy:true}])})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }